import React from 'react';
import styles from './BoardFourB.module.css';

const BoardFourB = ({ apiData }) => {
    // Extract data from apiData.deal
    const {
         salesPrice,
         salesTax,
         mvaFee,
         docFee,
         totalDue,
        downpayment,
        tradeAllowancePayoff,
        financeAmount,
    } = apiData.deal || {};

    return (
        <div className={styles.board}>
            <h2 className={styles.title}>New Finance</h2>
            <hr className={styles.divider} />
            <div className={styles.boardContainer}>
                {salesPrice && (
                    <div className={styles.row}>
                        <span className={styles.label}>Sale Price:</span>
                        <span className={styles.value}>${Number(salesPrice).toFixed(2)}</span>
                    </div>
                )}
                {salesTax && (
                    <div className={styles.row}>
                        <span className={styles.label}>Sales Tax:</span>
                        <span className={styles.value}>${Number(salesTax).toFixed(2)}</span>
                    </div>
                )}
                {mvaFee && (
                    <div className={styles.row}>
                        <span className={styles.label}>MVA Fee:</span>
                        <span className={styles.value}>${Number(mvaFee).toFixed(2)}</span>
                    </div>
                )}
                {docFee && (
                    <div className={styles.row}>
                        <span className={styles.label}>Doc Fee:</span>
                        <span className={styles.value}>${Number(docFee).toFixed(2)}</span>
                    </div>
                )}
                {totalDue && (
                    <>
                        <hr className={styles.separator} />
                        <div className={styles.row}>
                            <span className={styles.label}>Total Due:</span>
                            <span className={styles.value}>${Number(totalDue).toFixed(2)}</span>
                        </div>
                    </>
                )}
                {downpayment && (
                    <div className={styles.row}>
                        <span className={styles.label}>Down Payment:</span>
                        <span className={styles.value}>-${Number(downpayment).toFixed(2)}</span>
                    </div>
                )}
                {tradeAllowancePayoff && (
                    <div className={styles.row}>
                        <span className={styles.label}>Trade Allowance Payoff:</span>
                        <span className={styles.value}>${Number(tradeAllowancePayoff).toFixed(2)}</span>
                    </div>
                )}
                {financeAmount && (
                    <div className={styles.row}>
                        <span className={styles.label}>Base Financed Amount:</span>
                        <span className={styles.value}>${Number(financeAmount).toFixed(2)}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BoardFourB;
